import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';
import { useBotContext } from './store/BotContext';
import { IoChevronUpOutline, IoChevronDownOutline } from 'react-icons/io5';
import { ItineraryItem } from './types/bot.types';
import { formatBotPrice } from './search-results/formatBotPrice';

const ICONS: Record<string, string> = { flight: '✈️', hotel: '🏨', package: '📦', activity: '🎯', event: '🎫' };

interface Props {
  onRemove?: (displayName: string) => void;
}

const ItinerarySummaryCard: React.FC<Props> = ({ onRemove }) => {
  const { botState } = useBotContext();
  const t = useSelector((s: RootState) => (s.config.translations as any)?.bot);
  const [expanded, setExpanded] = useState(false);
  if (botState.selections.length === 0) return null;

  const count = botState.selections.length;
  const totalStr = `${botState.currency} ${formatBotPrice(botState.totalPrice)}`;
  const titleKey = count === 1 ? t?.itinerary?.titleOne : t?.itinerary?.titleOther;
  const summaryLabel = titleKey
    ? titleKey.replace('{{count}}', String(count)).replace('{{total}}', totalStr)
    : `${count} item${count > 1 ? 's' : ''} · ${totalStr}`;

  return (
    <div className="bot-itinerary">
      <div className="bot-itinerary__header" onClick={() => setExpanded(v => !v)}>
        <span className="bot-itinerary__summary">🗺️ {summaryLabel}</span>
        {expanded ? <IoChevronDownOutline size={18} /> : <IoChevronUpOutline size={18} />}
      </div>
      {expanded && (
        <div className="bot-itinerary__list">
          {botState.selections.map((item: ItineraryItem) => (
            <div key={item.selection_id} className="bot-itinerary__item">
              <span className="bot-itinerary__item-icon">{ICONS[item.product_type] ?? '📌'}</span>
              <div className="bot-itinerary__item-info">
                <div className="bot-itinerary__item-name">{item.display_name}</div>
                <div className="bot-itinerary__item-summary">{item.display_summary}</div>
              </div>
              <div className="bot-itinerary__item-price">{item.currency} {formatBotPrice(item.price)}</div>
              {onRemove && (
                <button
                  className="bot-itinerary__remove"
                  title={t?.itinerary?.remove ?? 'Remove'}
                  onClick={e => { e.stopPropagation(); onRemove(item.display_name); }}
                >
                  &times;
                </button>
              )}
            </div>
          ))}
          <div className="bot-itinerary__total">
            <span>{t?.itinerary?.total ?? 'Total'}</span>
            <strong>{botState.currency} {formatBotPrice(botState.totalPrice)}</strong>
          </div>
        </div>
      )}
    </div>
  );
};

export default ItinerarySummaryCard;
